<template>
  <div>
    <b-modal v-model="importingsurvey">
    </b-modal>
    <div v-show="consultant_id==0">
      <b-row class="col-12">
        <b-form-input
          v-model="search"
          placeholder="Search name or e-mail"
          type="text"
          @input="consultants_filter"
          class="col-9"
          autocomplete="off"
        >
        </b-form-input>
        <b-input-group-text slot="append">
          <b-btn variant="link" size="sm" @click="search = ''" class="p-0 i">
            X
          </b-btn>
        </b-input-group-text>      
      </b-row>
      <b-table
          id="consultants"
          hover
          :items="consultants"
          ref="consultants"
          @row-clicked="legacyconsultant_get"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner variant="primary" class="align-middle"></b-spinner>
            </div>
          </template>
          <template v-slot:cell(select)="data">
            <div class="py-1">
              <b-form-checkbox
                :id="'selected' + data.index"
                v-model="data.item.selected"
                @change="countselected"
              >
              </b-form-checkbox>
            </div>
          </template>
          <template v-slot:cell(consultant_name)="data">
            <div :class="`py-1 ${anon ? 'g-anon' : '' }`">
              {{ data.item.consultant_name }}
            </div>
          </template>
          <template v-slot:cell(email)="data">
            <div :class="`py-1 ${anon ? 'g-anon' : '' }`">
              {{ data.item.email }}
            </div>
          </template>
          <template v-slot:cell(actions)="data">
            <span 
              v-if="data.item.new_user_id==0"
              @click.prevent.stop="legacyconsultant_import(data.item)"
            >
              <fa-icon name="file-import" />
            </span>
            <span v-if="data.item.new_user_id!=0">
              <fa-icon name="eye" />
            </span>          
          </template>
        </b-table>      
    </div>
    <div v-show="consultant_id!=0">
      <b-button variant="outline-primary" @click.prevent="consultant_id=0" class="mr-4">&lt; Return to list</b-button>
      <h3>Surveys for <span :class="`py-1 ${anon ? 'g-anon' : '' }`">{{ consultant.consultant_name }}</span></h3>
      <b-table
        id="consultantsurveys"
        hover
        :fields="surveyfields"
        :items="consultant.surveys"
        ref="consultantsurveys"
      >
        <template v-slot:cell(actions)="data">
          <span 
            class="px-4"
            @click.prevent="legacysurvey_import(data.item)"
          >
            <fa-icon name="file-import" />
          </span>
          <span v-if="data.item.imported!=0">
            <fa-icon name="check" />
          </span>          
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

const surveyfields = [
  { key: "select", label: "", sortable: false },
  { key: "id", label: "ID", sortable: true },
  { key: "group_test_name", label: "Survey Name", sortable: true },
  { key: "group_test_start", label: "Start Date", sortable: true },
  { key: "group_test_end", label: "End Date", sortable: false },
  { key: "actions", label: "", sortable: false },
];
export default {
  data: function () {
    return {
      search: "",
      searching: false,
      searchcalc: false,
      consultant_id: 0,
      consultant: {},
      consultants: [],
      surveyfields: surveyfields,
      importingsurvey: false,
    }
  },
  computed: {
    anon: function() {
        return this.$store.state.anon;
    },
  },
  methods: {
    legacysurvey_import(item) {
      this.$store.dispatch('legacysurvey_import', { 
        id: item.id, 
        old_consultant_id: this.consultant_id, 
        new_consultant_id: this.consultant.new_user_id 
      })
      .then(() => {
        this.importingsurvey = item.id;
        this.legacyconsultant_get();
      })
    },
    legacyconsultant_import(item) {
      this.$store.dispatch('legacyconsultant_import', { id: item.id })
      .then(() => {
        this.consultants_get();
      })
    },
    legacyconsultant_get(item) {
      const legacyconsultant_id = item.id;
      this.$store.dispatch('legacyconsultant_get', { id: legacyconsultant_id })
      .then((resp) => {
        this.consultant = resp.data.result[0];
        this.consultant_id = item.id;
      })
    },
    consultants_filter: _.debounce(function () {
      this.searchcalc = true;
      setTimeout(
        function () {
          this.consultants_filterget();
          this.searchcalc = false;
          this.searching = false;
        }.bind(this),
        500
      );
    }, 300),
    consultants_filterget() {
      this.currentPage = 1;
      this.consultants_get();
    },
    consultants_get() {
      this.loading = true;
      var filter = "";
      if (this.search != "") {
        filter = {
          consultant_email: {
            operator: "LIKE",
            value: this.search,
          },
        };
      }
      this.$store.dispatch("legacyconsultant_search", {
          filter: filter,
        })
        .then((resp) => {
          this.consultants = [];
          for (var i = 0; i < resp.data.result.length; i++) {
            var result = {
              id: resp.data.result[i].id,
              consultant_name: resp.data.result[i].consultant_name,
              email: resp.data.result[i].email,
              surveys: resp.data.result[i].surveys,
              status: resp.data.result[i].new_user_id != 0 ? 'Imported as ID '+resp.data.result[i].new_user_id: 'Not imported',
              actions: '',
            };
            this.consultants.push(result);
          }
          this.rows = resp.data.total;
          this.loading = false;
        });
    },
  }
}
</script>
<style scoped>

</style>